import React, { FC, useState, useRef, useEffect } from "react";
import { App as AntdApp, Button, Flex, TableProps, Typography } from "antd";
import { FileZipOutlined } from "@ant-design/icons";
import { App } from "@/types/app";
import { getFileUrl } from "@/apis/file";
import { AddApp } from "./components/AddApp";
import { useTranslation } from "react-i18next";
import STableLayout, {
  DEFAULT_PAGE_SIZE,
  TableLayoutRef,
} from "@/styles/STableLayout";
import { ColumnsType } from "antd/lib/table";
import { AnyObject } from "antd/lib/_util/type";
import useDataList from "@/hooks/useDataList";
import { CommonListParams } from "@/types/common";
import { appList } from "@/apis/app";
import SText from "@/styles/SText";

const { Title } = Typography;

const AppManager: FC = () => {
  const { t } = useTranslation();
  const { notification } = AntdApp.useApp();
  
  const tableRef = useRef<TableLayoutRef | null>(null);
  const [openAdd, setOpenAdd] = useState<boolean>(false);

  const [list, total, listLoading, { fetchList, addItem }] = useDataList<App, [CommonListParams<string>]>({ fetchApi: appList });

  useEffect(() => {
    fetch(0);
  }, []);

  const headerChildren = (
    <React.Fragment>
      <Flex justify="space-between" align="center" style={{ width: "100%" }}>
        <Flex>
          <Title level={3}>{t("app.recordList")}</Title>
          <Button
            type="primary"
            onClick={() => setOpenAdd(true)}
            style={{ margin: "28px 0px 0px 10px" }}
          >
            {t("app.add")}
          </Button>
        </Flex>
        {/* <Flex style={{marginTop: 10}}>
          <Select defaultValue="all" style={{ width: 120 }} options={versionOptions} onChange={(val) => setVersionValue(val)}/>
          <Input.Search
            value={keyword}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {setKeyword(e.target.value)}}
            style={{ width: 200, marginLeft: 20 }}
          />
        </Flex> */}
      </Flex>
    </React.Fragment>
  );

  const appTableColumns: TableProps<App>["columns"] = [
    {
      title: t("app.versionNum"),
      dataIndex: "sequence",
      key: "sequence",
      width: 200,
    },
    {
      title: t("app.updateDesc"),
      dataIndex: "desc",
      key: "desc",
      width: 500,
      render: (preve: string) => <SText text={preve} />
    },
    {
      title: t("app.file"),
      key: "fileId",
      dataIndex: "fileId",
      render: (_, record) =>
        record.fileId ? (
          <FileZipOutlined
            onClick={() => downFileClick(record)}
            style={{ fontSize: 20, color: "#7a294f" }}
          />
        ) : (
          ""
        ),
    },
  ];

  const fetch = (offset: number) => {
    const take = tableRef.current?.pageSize ?? DEFAULT_PAGE_SIZE
    fetchList({ pagination: { offset, take }}).catch((err) => {
      switch (err) {
        case 10010:
          break;
        default:
          break;
      }
    });
  };

  const downFileClick = async (rowInfo: App) => {
    try {
      const downloadUrl = getFileUrl(rowInfo.fileId);
      if (downloadUrl) {
        const url = window.URL.createObjectURL(new Blob([downloadUrl]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.apk");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        notification.success({ placement: 'top', message: t("app.downTips") });
      }
    } catch (error) {
      notification.error({ placement: 'top',
        message: t("app.downFailError", { error: { error } }),
      });
    }
  };

  const handleAddApp = (appInfo: App) => {
    addItem(appInfo);
    setOpenAdd(false);
  };

  return (
    <Flex vertical style={{ width: "100%", height: "100%" }}>
      <STableLayout
        loading={listLoading}
        dataSource={list}
        columns={appTableColumns as ColumnsType<AnyObject>}
        scrollX={1400}
        headerChildren={headerChildren}
        tableLayoutRef={tableRef}
        total={total}
        handleChange={fetch}
      />
      <AddApp
        open={openAdd}
        onOk={handleAddApp}
        onCancel={() => setOpenAdd(false)}
      />
    </Flex>
  );
};

export default AppManager;
